import { render, staticRenderFns } from "./objetivosbuilder.vue?vue&type=template&id=2a8002b6&"
import script from "./objetivosbuilder.vue?vue&type=script&lang=ts&"
export * from "./objetivosbuilder.vue?vue&type=script&lang=ts&"
import style0 from "./objetivosbuilder.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports